import { render, staticRenderFns } from "./slideInicio.vue?vue&type=template&id=649adf5c&scoped=true"
import script from "./slideInicio.vue?vue&type=script&lang=js"
export * from "./slideInicio.vue?vue&type=script&lang=js"
import style0 from "./slideInicio.vue?vue&type=style&index=0&id=649adf5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649adf5c",
  null
  
)

export default component.exports